import { UserManagementHomePagePermissionRoute } from '@user-management/user-management-home-page';

export default function HomePage() {
  return <UserManagementHomePagePermissionRoute />;
}
